// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"538":"recorder","983":"profiler"}[chunkId] + "-" + {"538":"0038ca97ab326844247a","983":"254ff88037ac7557b85c"}[chunkId] + ".chunk.js";
};